import { IonActionSheet } from "@ionic/react";


function SingersList(props) {
    let currentDefaultSong = props.userAudios[props.name] ? -1 : props.devi;
    let currentUserSong = props.userAudios[props.name] ? props.userAudios[props.name].id : -1;
    return(
      <>
        <IonActionSheet
        isOpen={props.showActionSheet}
        mode="ios"
        className="singer-list"
        onDidDismiss={() => props.setShowActionSheet(false)}
        buttons={[
         ...props.defaultSingers.map((link, i) => {
          return {
           text: props.hindit && props.hindiName ? link.hlinkname : link.linkname,
           role: i===currentDefaultSong ? "destructive" : "",
           handler: () => {
            if(i === currentDefaultSong) return
            props.setFsing((prev) => {
             let dum = { ...prev };
             dum[props.name] = i;
             return dum;
            });
            props.setUserAudios((prev)=>{
              let dum = {...prev}
              dum[props.name] = null
              return dum
            })
            props.setDevi(i);
           },
          };
         }),
         ...(props.addedSongs[props.name] ? props.addedSongs[props.name] : []).map((link, i) => {
          return {
            "text": link.singer,
            role: i===currentUserSong ? "destructive" : "selected",
            handler: () => {
               if(i === currentUserSong) return
               props.setUserAudios((prev)=>{
                let dum = {...prev}
                dum[props.name] = {"id": i, "type": link.type, "linkname": link.singer, "hlinkname":link.singer,  "linkaddress": link.path}
                return dum
              })
            }
          }
         }),
         {
          text: "Add Audio",
          handler: () => {
            props.setAddSong(true)
          }
         },
         {
          text: "Cancel",
          role: "cancel",
          handler: () => {
          },
         },
        ]}
       ></IonActionSheet>
       </>
    );
}

export default SingersList